export const environment = {
    production: process.env.NODE_ENV === 'production',
    //points to backend
    serverApiUrl: 'https://prod-api.hauliermagic.co.uk/',
    hmr: false,
    heremapsTourPlanningCredentials: {
        appId: 'nA5sOc6N2Q9HpxzPc99v',
        apiKey: 'XAAFROElAbAQcUVngboUNPnS9XGD3DMKB74rdk1_G8w'
    },
    trackingApiUrl: 'https://es51gnfgwk.execute-api.eu-west-1.amazonaws.com/Prod/',
    env: 'prod',
    firebaseConfig: {
        apiKey: 'AIzaSyBk3RCjOeechP8nPetWNLBt4awh6Bpdlx0',
        authDomain: 'hauliermagic-test.firebaseapp.com',
        databaseURL: 'https://hauliermagic-test-default-rtdb.europe-west1.firebasedatabase.app',
        projectId: 'hauliermagic-test',
        storageBucket: 'hauliermagic-test.appspot.com',
        messagingSenderId: '1064323182776',
        appId: '1:1064323182776:web:9e2a01372dea94a3a2c44d',
        env: 'prod'
    },
    awsWafConfig: {
        apiKey: 'udQPafan3WaSpJSlsWYl2A5NIGm5//7xeZ1R7MM9DDeNUqRHpufomcGSMisqMKFnmsMnzbxV+zSefiO/Zgp37CoYhFJpRhJdse4j0dc9LRbmnmpi3T86+oXnsyQuNiU9Z5kzfdiGAv3RabhSRMh4GEB0mndOSrA9qF7uUt2M2wbgOwJvTeTWUvlsTaKOsoiahOSMlh/enhNz401SFUr3DUi3WDF/KqAphcWwN9zRd2X70icIo1dL9J7YrnZJL69m7+MiAjof/hH4CSJ43T5CQPmhwdfp03MeRpcxG16WcHIslHZ2SEfvtbiONeSMwJbwR7RV2dzaiI+SxmmI3aHoxmxgJ/prGlyOzvBRZtQnKBEIMRGeyTOds1DAJ3HQk9P5HvOBjVJkMwxbfTjAbR5YuChDCBaRdA7IcI3TKFodl54/BjVjUQMJXbJK3j8WOGl3HTIebSgmq5eCKC374RCOHtMVifNNnPmFjKV2Hp2dparsU81Hur9Iu6125FNKZxY6xNeZ9JVQvxr+P1kaUig8V7U76BpnvBDS8FwgrQpp4RfjZ+heuG4M2sN3CB/4/SInkTqGKnhpsMWwzLcIthgpDOUNQj3C0q133BFz+gPz9qhS0MEDOV2xBYAGm3VMMOvcMWxhiJquVH3SXjzGADoEowjhlwvmn8B/TKnaQnHgrGU=_1_1',
        url: 'https://1ecc7cebcb1c.edge.captcha-sdk.awswaf.com/1ecc7cebcb1c/jsapi.js'
    },
    dwtKey: 'f0068uQAAANFexqDvSAv09nQd0J52PQUbZe3jR5dlCPNsMCHkah/WxBozebpRyVXLvkpYKZuZDvm8Pvc766762lFH+OifhD0=',
    logUrl: 'https://lwk2e2mbqwaefp46ubrywqsxx40iombm.lambda-url.eu-west-1.on.aws/',
    newrelic: {
        init: {distributed_tracing: {enabled: true}, privacy: {cookies_enabled: true}},
        loader_config: {
            accountID: '3458937',
            trustKey: '3458937',
            agentID: '538505439',
            licenseKey: 'NRJS-5eb9afcf1921f2210b6',
            applicationID: '523483848'
        },
        info: {
            beacon: 'bam.eu01.nr-data.net',
            errorBeacon: 'bam.eu01.nr-data.net',
            licenseKey: 'NRJS-5eb9afcf1921f2210b6',
            applicationID: '523483848',
            sa: 1
        }
    },
    //make sure when you add a new api key, you add it to the csvBoxKeys object accross env.ts, env.prod.ts, env.staging.ts and ensure that it is whitelisted on the CSVbox admin panel
    csvBoxKeys: {
        haulierOrdersGtCar: {
            csvBoxLicenceKey: 'ndXpPeNI3C63t3HBuZKx9LR4g7q02j'
        },
        haulierOrdersGtLiquid: {
            csvBoxLicenceKey: 'Z83zwMy22s205XRpjDQtlV9EEFaVaw'
        },
        haulierOrdersGtDryBulk: {
            csvBoxLicenceKey: 'U9uajLxlxfR7EUkvxTTZobVb8DWvtt'
        },
        haulierOrdersGtPallet: {
            csvBoxLicenceKey: 'HMn2ixyNZtrz90xtzLDKtmK1syXU4Z'
        },
        haulierOrdersGtPalletForce: {
            csvBoxLicenceKey: 'oNoC42Nqx9JO7k5RhIKuZsO92tyQcW'
        },
        haulierOrdersGtContainer: {
            csvBoxLicenceKey: 'xr1BHnKgjECYxgmiWN8jkbry2ncMu3'
        },
        driver: {
            csvBoxLicenceKey: 'Uy3l5pHeFOJlIVTZqWyqtaPPnEe4iK'
        },
        locationPoint: {
            csvBoxLicenceKey: 'jbXu6A9Ly8kJAYNXQWGoEVpUNApXFZ'
        },
        exchangeRate: {
            csvBoxLicenceKey: 'oA4kWQsUR2uKzVvDMu6FUeqn6zauxm'
        },
        organisation: {
            csvBoxLicenceKey: 'baxXD0sA9vsum8r1x4e4XQgTNLeFug'
        },
        serviceLevel: {
            csvBoxLicenceKey: 'Gq34nrSmUBXiLgoBVGtTkmhUFPRm0H'
        },
        trafficArea: {
            csvBoxLicenceKey: 'oK2HRnvFEJMnFuG3IJr2rRDvljbwHF'
        },
        trailerType: {
            csvBoxLicenceKey: 'XyXyoFEIUsPEPS3wP6QBURH81KSn4K'
        },
        trailer: {
            csvBoxLicenceKey: 'XXYSKjkazV7hcTeiCVxxKhCDwQepFb'
        },
        vehicleClass: {
            csvBoxLicenceKey: 'OyjwSszlmQ0NQhXmrgtJRq5foEaKtt'
        },
        vehicle: {
            csvBoxLicenceKey: '77QMETMbDuCZz6gTaquV0LVFgJW5f7'
        },
        nominalCode: {
            csvBoxLicenceKey: 'EICJ58CvSajgxSVjreH9IbGXzftZKT'
        },
        controlArea: {
            csvBoxLicenceKey: 'RP52wLGAgbgDn4XmCpkQQp8hDxZuyH'
        },
        customGoodsType: {
            csvBoxLicenceKey: 'h5upswgk0cj5PkN45Qzvrl4nWUoexq'
        },
        businessType: {
            csvBoxLicenceKey: 'QLityOVtzvwacJLLMpK0rZtT9PNDdi'
        },
        fuelSurchargeGroup: {
            csvBoxLicenceKey: 'f7OKmdBIGynnDZJdQwTr4H8rgCsjnL'
        },
        person: {
            csvBoxLicenceKey: 'm4JJHohzd4dXH534zZZwtQ9Dif0Jy2'
        },
        driverType: {
            csvBoxLicenceKey: 'vI7WT79L49gQpRlfzrIpjFyRfIb9LA'
        },
        importBshOrder: {
            csvBoxLicenceKey: 'rItaBAHTHF1MS3nYGiwiiV4t31WzhI'
        },
        importPallexOrder: {
            csvBoxLicenceKey: '4PAmGO2WAo5UjpP3TLKzPiX75HUPLu'
        },
        specialType: {
            csvBoxLicenceKey: '9aq9HgEwK3UDywNqD31uExLm7mMpUG'
        }
    }
};
